import { call, put, takeLatest } from 'redux-saga/effects';
import actions from 'react/api/actions';

const { passwordPolicies: { actions: { fetchPolicies, fetchPoliciesSuccess } } } = actions;

export function fetchPoliciesApi(user) {
  return fetch(`/PasswordPolicy/ByLogin?login=${user}`, {
    method: 'GET',
  });
}

export function readReponse(response) {
  return response.json();
}

export function* policiesRequestSaga(action){

  const response = yield call(fetchPoliciesApi, action.payload);

  if (response.status < 400) {
    const policies = yield call(readReponse, response);
    yield put({ type: fetchPoliciesSuccess, policies });
  }
}

export default function* policiesRequest() {
  yield takeLatest(fetchPolicies, policiesRequestSaga);
}
